import { DemoSelectControl } from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Item from './Item';
import Output from './Output';

function Justify() {
  return (
    <FlexDemo
      initialValues={{
        '--direction': 'row',
        '--justify': 'flex-start',
        showAxisLabels: false,
      }}
      controls={[
        <DemoSelectControl
          inline
          key="--direction"
          id="--direction"
          label="flex-direction"
          options={['row', 'column']}
        />,
        <DemoSelectControl
          inline
          key="--justify"
          id="--justify"
          label="justify-content"
          options={[
            'flex-start',
            'center',
            'flex-end',
            'space-between',
            'space-around',
            'space-evenly',
          ]}
        />,
      ]}
    >
      {(state) => (
        <Output state={state}>
          <Item style={{ fontSize: '1.375rem' }}>Hello</Item>
          <Item>to</Item>
          <Item>the</Item>
          <Item style={{ fontSize: '1.375rem' }}>World</Item>
        </Output>
      )}
    </FlexDemo>
  );
}

export default Justify;
